import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {fetchEnquiryToCustomerReport} from "../../../state/reducers/EnquiryToCustomerSlice"
import { Bar } from "react-chartjs-2";

const EnquiryToCustomerChart = () => {
  const dispatch = useDispatch();
   const navigate = useNavigate();
  const { data, list, status, error } = useSelector((state) => state.enquiryToCustomer);

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchEnquiryToCustomerReport());
    }
  }, [dispatch, status]);

  if (status === "loading") return <p>Loading...</p>;
  if (status === "failed") return <p>Error: {error}</p>;
  const maxCount = Math.max(...data.map((item) => item.count)); // Find the maximum count value in your data

  const chartData = {
    labels: data.map((item) => item.week),
    datasets: [
      {
        label: "Leads Count",
        data: data.map((item) => item.count),
        backgroundColor: "#FF6B6B",
        borderColor: "rgba(255, 99, 132, 1)",
        borderWidth: 1,
      },
    ],
  };
  const chartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      // title: {
      //   display: true,
      //   text: "Weekly Leads Report",
      // },
    },
    scales: {
      y: {
        beginAtZero: true,
        max: maxCount, // Set Y-axis maximum to the highest count
        ticks: {
          stepSize: 1, // Increment by 1 for each line
          callback: function (value) {
            return value; // Return actual value for the tick label
          },
        },
      },
      x: {
        beginAtZero: true, // Ensure Y-axis starts at zero
      },
    },
  };
  const handleShowData = () => {
    navigate("/admin/data-table", { state: { leadsData: list } }); // Pass the data as route state
  };
  return (
    <div className="bg-white p-4 mb-4">
        <div className="flex justify-between">
        <h2 className="font-bold text-lg">Enquiry to Customer Report</h2>
      <button
        onClick={handleShowData}
        className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
      >
        Show Data
      </button>
        </div>
 
      <Bar data={chartData} options={chartOptions}/>
    </div>
  );
};

export default EnquiryToCustomerChart;
